module.exports = __webpack_public_path__ + "b611d52a8d5f31e8b210b40470cf03bb.woff";